module.exports = __webpack_public_path__ + "static/media/34.4b2ddb18.jpg";